import firebase from "firebase";

export default {
    namespaced: true,
    state: {
        mPendingForDeploy:[],
        mAssetUploadResult:[],
    },
    getters: {
        getPendingForDeploy: state => {
            return state.mPendingForDeploy;
        },
        getAssetUploadResult: state => {
            return state.mAssetUploadResult;
        },
    },
    mutations: {
        setAssetUploadResult(state, values) {
            state.mAssetUploadResult = values;
        },
        setPendingForDeploy(state, values) {
            state.mPendingForDeploy = values;
        },
        addPendingForDeploy(state, values) {
            if (!state.mPendingForDeploy.includes(values)){
                state.mPendingForDeploy.push(values);
            }
        },
        removePendingForDeploy(state, value) {
            let arr = state.mPendingForDeploy;
            arr = arr.filter(item => item !== value);
            state.mPendingForDeploy = arr;
        },
    },
    actions: {
        init(/*{commit}*/) {
            console.info('deploy-store initialized.');
        },
        crossDeploy({commit}, data){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data) // array of keys
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'crossDeploy', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    commit("setPendingForDeploy", [])
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethAssetUploadResult({commit}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getLastAssetUploadResult', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    data.text()
                                    .then((data)=>{
                                        commit("setAssetUploadResult", JSON.parse(data))
                                    }).catch((error) => {
                                        throw error
                                    })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

